import React from 'react'
import styled from '@emotion/styled'
import MovieCardLarge from './MovieCardLarge'
import AdComponent from './AdComponent'

const MovieCardLargeList = props => {
  if (!props.movies.length) {
    const movieCardList = []
    for (let i = 0; i < 20; i++) {
      movieCardList.push(<MovieCardLarge skeleton key={i}/>)
    }
    return movieCardList
  }
  const movieCardList = props.movies.map((i, count) => {
    return (
      <div>
        <MovieCardLarge movie={i} watchlist={props.watchlist} key={i.id}/>
      </div>
    )
  })
  return (
  <div>
    {movieCardList}
  </div>
  )
}

export default MovieCardLargeList


// {
//   count % 10 === 0 && count !== 0 &&
//     <Container>
//       <AdComponent client="ca-pub-3093835180445554" slot="6680236143" customClasses="my-3"/> 
//       {/* <NativeAd client="ca-pub-3093835180445554" slot="8635321424" customClasses="my-3"/>  */}
//     </Container>
//   }

const Container = styled.div`
  display: flex;
  margin: 1em auto;
  /* max-width: 590px; */
  /* background-color: #FFF; */
  /* max-height: 225px; */
  /* overflow: hidden; */
`